<template>
  <div>
    <MiniDivider />
    <div class="font-size">
      <div class="mb-5">
        <a :href="NRS_GO_TERMS" target="_blank" rel="noreferrer">
          <span class="color-suva-grey">Terms and Conditions</span>
        </a>
      </div>
      <div class="mb-5">
        <a :href="NRS_PLUS_PRIVACY_POLICY" target="_blank" rel="noreferrer">
          <span class="color-suva-grey">Privacy Policy</span>
        </a>
      </div>
      <div v-if="!canada" class="mb-5">
        <a :href="IDT_CCPA" target="_blank" rel="noreferrer">
          <span class="color-suva-grey"
            >California Consumer Privacy Notice</span
          >
        </a>
      </div>
      <div v-if="!canada" class="mb-5">
        <a :href="IDT_VDCPA" target="_blank" rel="noreferrer">
          <span class="color-suva-grey">Virginia Consumer Privacy Notice</span>
        </a>
      </div>
      <div v-if="!canada" class="mb-5">
        <a :href="IDT_CCPA_OPT_OUT" target="_blank" rel="noreferrer">
          <span class="color-suva-grey"
            >Do Not Sell My Personal Information</span
          >
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import urls from "@/urls.json";
import MiniDivider from "@/elements/MiniDivider.vue";
import { mapGetters } from "vuex";

export default {
  name: "LegalLinksNav",
  components: { MiniDivider },
  computed: {
    ...mapGetters("store", {
      canada: "canada",
    }),
  },
  created() {
    this.NRS_GO_TERMS = urls.NRS_GO_TERMS;
    this.NRS_PLUS_PRIVACY_POLICY = this.canada
      ? urls.NRS_PLUS_PRIVACY_POLICY_CANADA
      : urls.NRS_PLUS_PRIVACY_POLICY;
    this.IDT_CCPA = urls.IDT_CCPA;
    this.IDT_VDCPA = urls.IDT_VDCPA;
    this.IDT_CCPA_OPT_OUT = urls.IDT_CCPA_OPT_OUT;
  },
};
</script>
<style scoped>
.font-size {
  font-size: var(--font-size-xs);
}
@media (min-width: 668px) {
  .font-size {
    font-size: var(--font-size-sm);
  }
}
</style>
